// API Configuration
const getApiBaseUrl = () => {
  // Check hostname first (for local network access)
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    console.log('✅ Detected hostname:', currentHost);
    
    // Priority 1: If accessing via local IP 192.168.200.80, use local API (override env var)
    if (currentHost === '192.168.200.80') {
      console.log('✅ Using local network backend: http://192.168.200.80:5000');
      return 'http://192.168.200.80:5000';
    }
    
    // Priority 2: If accessing via localhost or 127.0.0.1, use local API (override env var)
    if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
      console.log('✅ Using localhost backend: http://localhost:5001');
      return 'http://localhost:5001';
    }
  }
  
  // Priority 3: Environment variable (for production builds)
  if (process.env.REACT_APP_API_URL) {
    console.log('✅ Using REACT_APP_API_URL from environment:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }
  
  // Priority 4: Check hostname for production domains
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    
    // If accessing via app.chpbek.com, use production server
    if (currentHost === 'app.chpbek.com') {
    console.log('✅ Using production backend: https://web.chpbek.com');
    return 'https://web.chpbek.com';
  }
  
    // If accessing via web.chpbek.com, use production server
    if (currentHost === 'web.chpbek.com') {
      console.log('✅ Using production backend: https://web.chpbek.com');
      return 'https://web.chpbek.com';
    }
  }
  
  // Default fallback - use production server
  console.log('✅ Using production backend (default): https://web.chpbek.com');
  return 'https://web.chpbek.com';
};

export const API_BASE_URL = getApiBaseUrl();

// Debug logging - Always show in production for troubleshooting
console.log('🔍 API Configuration Debug:');
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('Current Hostname:', typeof window !== 'undefined' ? window.location.hostname : 'server-side');
console.log('Current URL:', typeof window !== 'undefined' ? window.location.href : 'server-side');
console.log('✅ Final API_BASE_URL:', API_BASE_URL);

// Helper function to create full API URLs
export const createApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Helper function to create API URLs with /api prefix
export const createApiUrlWithPrefix = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/api/${cleanEndpoint}`;
};

// Helper function to get user image URL (checks both photoPath and imagePath)
export const getUserImageUrl = (user) => {
  if (!user) {
    console.log('🖼️ getUserImageUrl: No user provided');
    return null;
  }
  
  // Check both photoPath and imagePath (handle both camelCase and PascalCase)
  const photoPath = user.photoPath || user.PhotoPath;
  const imagePath = user.imagePath || user.ImagePath;
  
  // Use photoPath first, fallback to imagePath
  // NOTE: Both mobile and web apps use this same preference (photoPath > imagePath)
  const finalPath = photoPath || imagePath;
  
  // Log if both paths exist but are different (shouldn't happen, but helps debug)
  if (photoPath && imagePath && photoPath !== imagePath) {
    console.warn('⚠️ Image path mismatch detected:', {
      photoPath,
      imagePath,
      userId: user.id,
      using: finalPath
    });
  }
  
  // Log for debugging (only in development or local network)
  const isDev = process.env.NODE_ENV !== 'production';
  const isLocalNetwork = typeof window !== 'undefined' && window.location.hostname === '192.168.200.80';
  
  if (isDev || isLocalNetwork) {
    console.log('🖼️ getUserImageUrl for user:', {
      id: user.id,
      name: user.name,
      photoPath: photoPath,
      imagePath: imagePath,
      finalPath: finalPath,
      role: user.role
    });
  }
  
  // Check if path exists and is not empty string
  if (!finalPath || finalPath.trim() === '') {
    if (isDev || isLocalNetwork) {
      console.log('🖼️ No image path found for user:', user.id);
    }
    return null;
  }
  
  const fullUrl = createApiUrl(finalPath);
  
  // Add cache-busting parameter using multiple strategies:
  // 1. Use updatedAt timestamp if available (from database)
  // 2. Use image path hash (filename changes when new image is uploaded)
  // 3. Add current timestamp to ensure fresh fetch
  const updatedAt = user.updatedAt || user.UpdatedAt;
  const imagePathHash = finalPath ? finalPath.split('/').pop() : '';
  const timestamp = updatedAt 
    ? new Date(updatedAt).getTime() 
    : Date.now();
  
  // Combine all cache-busting strategies for maximum effectiveness
  const cacheBuster = `?t=${timestamp}&v=${imagePathHash}&r=${Date.now()}`;
  
  const finalUrl = fullUrl + cacheBuster;
  
  if (isDev || isLocalNetwork) {
    console.log('🖼️ Generated image URL:', {
      finalPath,
      fullUrl,
      updatedAt,
      cacheBuster,
      finalUrl
    });
  }
  
  return finalUrl;
};